import { useAbility } from "@casl/react";
import { AbilityContext } from "../../../config/abilityContext";
import Logo from "./components/Logo";
import SearchBar from "./components/SearchBar";
import LanguageDropdown from "./components/LanguageDropdown";
import NotificationDropdown from "./components/NotificationDropdown";
import FullscreenToggle from "./components/FullscreenToggle";
import UserDropdown from "./components/UserDropdown";
import QuickAddDropdown from "./components/QuickAddDropdown";
import AcademicYearDropdown from "./components/AcademicYearDropdown";
import WorkspaceSwitcher from "./components/WorkspaceSwitcher";
import MobileUserDropdown from "./components/MobileUserDropdown";

const Header = () => {
  const ability = useAbility(AbilityContext);
  const showQuickAddDropdown = ability.can("getAll", "Class") && ability.can("create", "Class") || ability.can("getAll", "Teacher") && ability.can("create", "Teacher") || ability.can("getAll", "Student") && ability.can("create", "Student") || ability.can("getAll", "Guardian") && ability.can("create", "Guardian");

  return (
    <>
      {/* Header */}
      <div className="header">
        {/* Left Section: Logo & Sidebar Toggle */}
        <Logo />

        {/* Mobile Sidebar Toggle */}
        <div className="d-md-none">
          <Logo /> {/* Includes Sidebar Toggle inside */}
        </div>

        <div className="header-user">
          <div className="nav user-menu">
            <SearchBar />
            <WorkspaceSwitcher />
            <AcademicYearDropdown />
            <LanguageDropdown />

            {/* Restrict QuickAddDropdown to users who can "manage" "subjects" or "teachers" */}
            {showQuickAddDropdown ? (
              <QuickAddDropdown />
            ) : null}

            <NotificationDropdown />
            <FullscreenToggle />
            <UserDropdown />
          </div>
        </div>
        <div className="dropdown mobile-user-menu">

          <MobileUserDropdown />

        </div>
      </div>
    </>
  );
};

export default Header;
